export default "/static/images/marker.png";